/* eslint-disable no-nested-ternary */
import React from 'react';
import IconUpDownArrow from '../../icons/IconUpDownArrow';
import MultipleSelect from '../../fields/MultipleSelect/MultipleSelect';
import { handleValueSelected } from '../../../utils/builder/common';
import dayjs from 'dayjs';
import DateRangePicker from '../../elements/DateRangePicker/DateRangePicker';
export const defaultDateRange = [
  dayjs().subtract(6, 'day').toDate(),
  dayjs().toDate(),
];

export const initialValues = {
  startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
  endDate: dayjs().format('YYYY-MM-DD'),
  regional: '',
  provinceId: '',
  cityId: '',
  districtId: '',
  villageId: '',
};

export const Fields = ({
  values = initialValues,
  handleChangeValues,
  dropdownData,
  regionalId,
  handleSearchFilter,
  setValueDate,
  valueDate
}) => {
  const datePickerProps = {
    dropdownPosition: 'bottom-start',
    allowSingleDateInRange: true,
    maxDate: dayjs().toDate(),
    valueFormat: 'DD MMM YYYY',
    locale: 'id',
    placeholder: 'Pilih periode',
    rightSection: <IconUpDownArrow />,
    size:'xs',
  };

  return [
    {
      label: 'Periode',
      component: (
        <DateRangePicker
          inputProps={datePickerProps}
          maxDate={new Date()}
          onChange={(value) => {
            setValueDate(value);
            if (Object.values(value).every((item) => Boolean(item))) {
              handleChangeValues({
                name: 'registrationDate',
                value,
              });
            }
          }}
          type="range"
          value={valueDate}
        />
      ),
    },
    {
      label: 'Regional',
      disabled: !!regionalId,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.regional}
          disabled={!!regionalId}
          eventName="regional"
          hideLabel
          name="regional"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'regional', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua Regional"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={handleValueSelected(values.regional, regionalId)}
        />
      ),
    },
    {
      label: 'Provinsi',
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.provinces}
          eventName="provinces"
          hideLabel
          name="provinceId"
          onChange={(value) =>{
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'provinceId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          overflow={'unset'}
          placeholder="Semua Provinsi"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.provinceId}
        />
      ),
    },
    {
      label: 'Kota/Kab',
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.cities}
          debounce={true}
          eventName="cities"
          hideLabel
          name="cityId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'cityId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kota/Kab"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.cityId}
        />
      ),
    },
    {
      label: 'Kecamatan',
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.districts}
          debounce={true}
          eventName="districts"
          hideLabel
          name="districtId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '*');
            handleChangeValues({ name: 'districtId', value: isSelectedAll > -1 || value.length === 0 ? '*' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kecamatan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.districtId}
        />
      ),
    },
    {
      label: 'Kelurahan' ,
      component: (
        <MultipleSelect
          border={false}
          data={dropdownData.villages}
          debounce={true}
          eventName="villages"
          hideLabel
          name="villageId"
          onChange={(value) => {
            const isSelectedAll = value.findIndex((val) => val === '');
            handleChangeValues({ name: 'villageId', value: isSelectedAll > -1 || value.length === 0 ? '' : value });
          }
          }
          onSearchChange={handleSearchFilter}
          overflow={'unset'}
          placeholder="Semua Kelurahan"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          value={values.villageId}
        />
      ),
    },
  ];
};
